import logger from '../../services/logger';

import React from "react";
import SPAREKACallPlan from "../common/SPAREKACallPlan";
import { PageTitle } from "../common/Header";
import { useLocation } from 'react-router-dom';

const CallPlanning = () => {
    // Récupérer l'objet univer depuis l'état de location
    const location = useLocation();
    // Récupérer les objets product et event de location.state
    const {product} = location.state || {};
    logger.log("product", product); 
     return (
        <div className="white-background">
            <PageTitle title="Prendre rendez-vous" />
            <SPAREKACallPlan 
                className="mt-3 mb-3 h-100" 
                product={product || ""} 
            />
            <br/><br/>
        </div>
    );
};

export default CallPlanning;